import { atom } from 'jotai'

import { SidebarState } from '../types/SidebarStates'


export const sidebarAtom = atom<SidebarState>({ open: false })

export const closeSidebarAtom = atom(
  null, // no read functionality
  (_get, set) => {
    set(sidebarAtom, { open: false })
  }
)
